import React, { useState } from "react";
import { Link } from "react-router-dom";

function Aside() {
  const [openMenus, setOpenMenus] = useState({
    myAccount: false,
    report: false,
    tongle: false,
  });

  const toggleMenu = (menu) => {
    setOpenMenus((prevOpenMenus) => ({
      ...prevOpenMenus,
      [menu]: !prevOpenMenus[menu],
    }));
  };

  return (
    <aside className={`sidenav ${openMenus.tongle ? 'toggle' : ''}`}>
      <nav className="page-sidebar">
        <div className="sidenav-brand">
          <span className="text">Welcome</span>
          <button onClick={() => toggleMenu("tongle")} className="btn-sidenav">
            <span className="ic-menu" />
          </button>
        </div>
        <ul id="sidebarMenu" className="menu">
          <li className="menu-item">
            <Link to="/dashboard" className="menu-link"> 
              <span className="ic-home" /> Dashboard
            </Link>
          </li>

          <li className="menu-item">
            <span
              className={`menu-link dropdown-toggle ${openMenus.myAccount ? "active" : ""}`}
              onClick={() => toggleMenu("myAccount")}
            >
              <span className="ic-user-outline" /> My Account
            </span>
            <ul className={`submenu ${openMenus.myAccount ? "submenu-open" : "submenu-closed"}`}>
              <li className="submenu-item">
                <Link to="/profile" className="submenu-link">Profile</Link>
              </li>
              <li className="submenu-item">
                <Link to="/bank" className="submenu-link">Bank</Link>
              </li>
              <li className="submenu-item">
                <Link to="/hierarchy" className="submenu-link">Hierarchy</Link>
              </li>
              <li className="submenu-item">
                <Link to="/kyc" className="submenu-link">Affiliate KYC</Link>
              </li>
            </ul>
          </li>

          <li className="menu-item">
            <Link to="/material" className="menu-link">
              <span className="ic-multiple" /> Material
            </Link>
          </li>

          <li className="menu-item">
            <span
              className={`menu-link dropdown-toggle ${openMenus.report ? "active" : ""}`}
              onClick={() => toggleMenu("report")}
            >
              <span className="ic-report" /> Report
            </span>
            <ul className={`submenu ${openMenus.report ? "submenu-open" : "submenu-closed"}`}>
              <li className="submenu-item">
                <Link to="/member" className="submenu-link">Member Search</Link>
              </li>
              <li className="submenu-item">
                <Link to="/registration" className="submenu-link">Registrations &amp; FTDs</Link>
              </li>
              <li className="submenu-item">
                <Link to="/performance" className="submenu-link">Performance</Link>
              </li>
              <li className="submenu-item">
                <Link to="/commission" className="submenu-link">Commission</Link>
              </li>
            </ul>
          </li>
        </ul>
      </nav>
    </aside>
  );
}

export default Aside;
